var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader-fade"}},[(_vm.showLoadingIndicator)?_c('div',{class:[_vm.classes]}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }